import Mutations from '../../odata/mutations';

export default { ...new Mutations('costLine'), ...new Mutations('costLines') };
